<!-- Start::payment type -->
<form [formGroup]="form">
  @if(isLoading){
  <!-- End::skeleton -->
  <div class="flex flex-column gap-3">
    @for(type of [1, 2, 3]; track $index){
    <div
      class="border-1 surface-border border-round p-3 flex align-items-center cursor-pointer h-8rem md:h-7rem"
    >
      <p-skeleton shape="circle" size="1rem" class="mr-3" />
      <div class="flex flex-column gap-2">
        <p-skeleton width="12rem" />
        <p-skeleton styleClass="sm:28rem" />
      </div>
      <div class="ml-auto flex flex-nowrap">
        <p-skeleton styleClass="w-4rem h-4rem" />
      </div>
    </div>
    }
  </div>
  <!-- End::skeleton -->
  } @else {
  <!-- Items -->
  <div class="flex flex-column gap-3">
    @for(type of payments; track $index){
    <div
      class="border-1 p-3 border-round flex align-items-center cursor-pointer h-8rem md:h-7rem"
      [ngClass]="{
        'surface-border hover:border-400':
          paymentTypeField.value !== type.code,
        'border-primary bg-blue-50': paymentTypeField.value === type.code
      }"
      (click)="onSelectPaymentType(type.code)"
    >
      <p-radioButton
        name="paymentType"
        [value]="type.code"
        formControlName="paymentType"
        styleClass="mr-3"
      ></p-radioButton>
      <div class="mr-4 md:mr-8">
        <div class="font-semibold" [ngClass]="{ 'mb-1': type.description }">
          {{ type.name }}
        </div>
        @if(type.description){
        <span class="text-sm">{{ type.description }}</span>
        }
      </div>

      @if(type.iconImage){
      <div class="ml-auto flex flex-nowrap">
        <img [src]="type.iconImage" class="w-4rem md:w-5rem" />
      </div>
      }
    </div>
    }
  </div>
  }
</form>
<!-- End::payment type -->
